import React from "react";
import AsideMenuItems from "./AsideMenuItems";
import { ReactComponent as VenueIcon } from "../../assets/venu-ico.svg";
import { ReactComponent as DashboardIcon } from "../../assets/dashboard-ico.svg";
import { ReactComponent as EventsIcon } from "../../assets/events-ico.svg";
import { useUser } from "../../context/UserContext";
import { ReactComponent as SettingsIcon } from "../../assets/setting.svg";

function Sidebar() {
  const { isSimpleUser } = useUser();
  return (
    <>
      <div className="p-3 h-[83%] overflow-y-auto">
        <ul className="p-0 m-0">
          {isSimpleUser ? (
            <AsideMenuItems Icon={EventsIcon} title={"Events"} to={"/events"} />
          ) : (
            <>
              <AsideMenuItems
                Icon={DashboardIcon}
                title={"My Dashboard"}
                to={"/"}
              />
              <AsideMenuItems
                Icon={VenueIcon}
                title={"My Venues"}
                to={"/venue"}
              />
              <AsideMenuItems
                Icon={EventsIcon}
                title={"My Events"}
                to={"/events"}
              />
              <AsideMenuItems
                Icon={SettingsIcon}
                title={"Settings"}
                to={"/settings"}
              />
            </>
          )}
        </ul>
      </div>
    </>
  );
}

export default Sidebar;
